import { PurchaseItems } from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import { Button, Divider, Space, Steps, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import ConfirmManufacturerAndSubGroup from '../../ConfirmManufacturerAndSubGroup';
import ConfirmNcmAndCfopForm from '../../ConfirmNcmAndCfopForm';
import { useWindowSize } from '@/hooks';

interface Props {
  hasOutputCfopOnImportPurchase?: boolean;
  onCancel: () => void;
  unlinkItems: PurchaseItems[];
  setUnlinkItems: React.Dispatch<React.SetStateAction<PurchaseItems[]>>;
  onCallback: (data?: PurchaseItems[]) => void;
  asUnlinkItems?: boolean;
  confirmLoading?: boolean;
}

const ConfirmImportPurchaseSteps: React.FC<Props> = ({
  onCancel,
  unlinkItems,
  setUnlinkItems,
  onCallback,
  asUnlinkItems,
  confirmLoading,
  hasOutputCfopOnImportPurchase,
}) => {
  const [step, setStep] = useState(0);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (asUnlinkItems) {
      setStep(1);
    } else {
      setStep(0);
    }
  }, [asUnlinkItems]);

  const steps = [
    <div key={0}>
      <ConfirmManufacturerAndSubGroup
        unlinkItems={unlinkItems}
        setUnlinkItems={setUnlinkItems}
      />

      <Divider />
    </div>,

    <div key={1}>
      <ConfirmNcmAndCfopForm
        hasOutputCfopOnImportPurchase={hasOutputCfopOnImportPurchase}
      />

      <Divider />
    </div>,
  ];

  const hasAllItemsCompleted = unlinkItems.every(
    (item) => !!item.manufacturerId && !!item.subGroupId,
  );

  return (
    <>
      <Steps current={step} style={{ marginBottom: '24px' }}>
        <Steps.Step
          title={!asUnlinkItems && step === 0 ? 'Inclusão' : 'Concluído'}
          description={
            !asUnlinkItems
              ? 'Inclua os Fabricantes e os Grupos em cada peça.'
              : 'Passo concluído, pois todas as peças possui vínculo.'
          }
        />

        <Steps.Step
          title="Inclusão"
          description={'Selecione os CFOP`s ou tributos dos NCM`s necessários.'}
        />
      </Steps>

      {steps[step]}

      <Space style={{ width: '100%', justifyContent: 'end' }}>
        <Button onClick={onCancel} disabled={confirmLoading}>
          <FormattedMessage id="commons.modal.button.cancel" />
        </Button>

        {step > 0 && step <= 2 && !asUnlinkItems ? (
          <Button
            onClick={() => setStep((prev) => prev - 1)}
            disabled={confirmLoading}
          >
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        ) : null}

        {step < 1 ? (
          <Tooltip
            open={
              isMobile &&
              unlinkItems.every(
                (item) => !item.manufacturerId || !item.subGroupId,
              )
            }
            placement={'bottom'}
            title={
              'Arraste a listagem para o lado direito para selecionar o fabricante e o subGrupo'
            }
          >
            <Button
              type="primary"
              onClick={async () => {
                setStep((prev) => prev + 1);
              }}
              disabled={!hasAllItemsCompleted || confirmLoading}
            >
              <FormattedMessage id="commons.modal.button.next" />
            </Button>
          </Tooltip>
        ) : null}

        {step === 1 ? (
          <Button
            type="primary"
            onClick={() => onCallback(unlinkItems)}
            loading={confirmLoading}
          >
            Confirmar Importação
          </Button>
        ) : null}
      </Space>
    </>
  );
};

export default ConfirmImportPurchaseSteps;
